import { render, staticRenderFns } from "./UpgradeDialog.vue?vue&type=template&id=f789c120&scoped=true"
import script from "./UpgradeDialog.vue?vue&type=script&lang=js"
export * from "./UpgradeDialog.vue?vue&type=script&lang=js"
import style0 from "./UpgradeDialog.vue?vue&type=style&index=0&id=f789c120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f789c120",
  null
  
)

export default component.exports